module.exports = __webpack_public_path__ + "img/swve_fort_buendeln.08428070.png";